import React, { Fragment, useEffect, useState, forwardRef } from 'react';
import { translate } from '../../../Services/translation';
import { get, post } from '../../../Services/http';
import DatePicker from "react-datepicker";
import { BACKEND_LOGGEND_IN_SHOPID, isEcomAdmin } from '../../Services/Api.service';

const CompletedOrderOneTimeAndSubscriptionExport = (props) => {
    let initialAvailableDate = {
        mindate: new Date(),
        maxdate: new Date()
    }    
    const [availableDates, setavailableDates] = useState(initialAvailableDate);
    const [startDate, setstartDate] = useState('');
    const [endDate, setendDate] = useState('');
    const [startDateError, setstartDateError] = useState(false); 
    const [startDateFormatted, setstartDateFormatted] = useState('');
    const [endDateFormatted, setendDateFormatted] = useState('');  
    const [error, seterror] = useState('');
    const [downloadInProgress, setdownloadInProgress] = useState(false);

    useEffect(() => {
        const currentFullDate = new Date();
        const availableFullDate = new Date(currentFullDate.getFullYear() - 10, currentFullDate.getMonth(), currentFullDate.getDate());
        setavailableDates({mindate: availableFullDate, maxdate: currentFullDate});
    }, []);

    useEffect(() => {
        if (startDate) {
            const startDateValue = new Date(startDate);            
            setstartDateFormatted(`${String(startDateValue.getDate()).padStart(2, '0')}-${String(startDateValue.getMonth() + 1).padStart(2, '0')}-${startDateValue.getFullYear()}`);
        }       
    }, [startDate]);

    useEffect(() => {  
        if (endDate) {
            const endDateValue = new Date(endDate); 
            setendDateFormatted(`${String(endDateValue.getDate()).padStart(2, '0')}-${String(endDateValue.getMonth() + 1).padStart(2, '0')}-${endDateValue.getFullYear()}`);
        }              
    }, [endDate]);

    const DatePickerInputStart = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={startDateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });

    const DatePickerInputEnd = forwardRef((data, ref) => {
        const [readOnly, setReadOnly] = useState(false);
        return (
            <div className='completedorderexport__datepicker' onClick={data.onClick} ref={ref} >
                <input className="register__datepicker-input" placeholder={data.placeholder} autoComplete="off" value={endDateFormatted} onChange={data.onChange}
                        onFocus={() => setReadOnly((window.innerWidth <= 760))}
                        onBlur={() => setReadOnly(false)}
                        readOnly={readOnly} />
                <div className="register__datepicker-icon" />
            </div>
        );
    });

    const getOrderSearchResponse = () => {
        if (!startDate) {
            setstartDateError(true);
        }        

        if (startDate) {                   
            setdownloadInProgress(true);
            get(`api/ordersearch/getreportsplitordertype/${localStorage.getItem(BACKEND_LOGGEND_IN_SHOPID)}/${props.FilterCompletedDate}/${startDateFormatted}/${endDateFormatted}/${isEcomAdmin()}`, true)
                .then((response) => response.blob())
                .then((blob) => {
                    setdownloadInProgress(false);
                    seterror(false);
                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(blob);

                    // Create a link element to trigger the download
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'CompletedOrders.xlsx'; // Set the desired file name
                    a.click();

                    // Revoke the object URL to free up resources
                    window.URL.revokeObjectURL(url);
                })
                .catch((ex) => {
                    setdownloadInProgress(false);
                    seterror(true);
                });
        }        
    }

    return(
    <Fragment>        
            {error && <div className="error">{translate("coptikk.adminportal.completedorders.error")}</div>}            
            <div className='completedorderexport__datepicker'>
                <label>{translate("coptikk.adminportal.completedorders.startdate")}</label>
                <div className="column small-3">
                    {window.innerWidth <= 760 ?
                        <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => setstartDate(date)}
                            popperClassName="booking"
                            customInput={<DatePickerInputStart />}                            
                        /> : <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => setstartDate(date)}
                            customInput={<DatePickerInputStart />}
                        />}
                </div>            
                <label>{translate("coptikk.adminportal.completedorders.enddate")}</label>
                <div className="column small-3">
                    {window.innerWidth <= 760 ?
                        <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={startDate ? startDate : availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => setendDate(date)}
                            popperClassName="booking"
                            customInput={<DatePickerInputEnd />}                            
                        /> : <DatePicker                            
                            dateFormat="dd.MM.yyyy"
                            placeholderText={translate("coptikk.register.selectdate")}                            
                            locale="nb"
                            minDate={startDate ? startDate : availableDates.mindate}
                            maxDate={availableDates.maxdate}
                            onChange={(date) => setendDate(date)}
                            customInput={<DatePickerInputEnd />}
                        />}
                </div>
                <div className='column small-3'>                    
                    {downloadInProgress ? <button className='button large expanded disabled'>{translate("coptikk.adminportal.report.downloadinprogress")}</button>
                    : <button className='button large expanded' onClick={() => getOrderSearchResponse()}>{translate("coptikk.adminportal.completedorders.download")}
                    </button>}
                </div>
            </div>                    
    </Fragment>)
}

export default CompletedOrderOneTimeAndSubscriptionExport;